module.exports = __webpack_public_path__ + "img/HQ-PA2W1L-T.27eea81f.jpg";